var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManageWorkspace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0833 12.2584V2.91413C11.0833 2.26904 10.561 1.74609 9.91667 1.74609H4.08333C3.439 1.74609 2.91667 2.26904 2.91667 2.91413V12.2584M11.0833 12.2584L12.25 12.2584M11.0833 12.2584H8.16667M2.91667 12.2584L1.75 12.2584M2.91667 12.2584H5.83333M5.25 4.08215H5.83333M5.25 6.41822H5.83333M8.16667 4.08215H8.75M8.16667 6.41822H8.75M5.83333 12.2584V9.3383C5.83333 9.01576 6.0945 8.75429 6.41667 8.75429H7.58333C7.9055 8.75429 8.16667 9.01576 8.16667 9.3383V12.2584M5.83333 12.2584H8.16667",
    stroke: "#7A8699",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageWorkspace);
export default __webpack_public_path__ + "static/media/manage-workspace.86b8e813d052275d772feeea84be6009.svg";
export { ForwardRef as ReactComponent };